import firebase from 'firebase/app';
firebase.analytics();
